import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { CustomDateFormatPipe } from '../../../../../../pipes/custom-date-format.pipe';
import { HospitalTitlecasePipe } from '../../../../../../pipes/hospital-titlecase.pipe';

@Component({
  selector: 'app-modal-inclusion-economia-per-reg',
  imports: [CommonModule, CustomDateFormatPipe, HospitalTitlecasePipe],
  templateUrl: './modal-inclusion-economia-per-reg.component.html',
  styleUrl: './modal-inclusion-economia-per-reg.component.css',
})
export class ModalInclusionEconomiaPerRegComponent implements OnInit {
  @Input() regionId!: number | null;
  @Input() medicineId!: number;
  @Input() countryId!: number;
  @Input() regionName!: string | null;
  @Input() regionPercentage!: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  isLoading = true;
  hospitalList: any[] = [];
  onekeys: any[] = [];

  get isDataEmpty(): boolean {
    return !this.isLoading && this.hospitalList.length === 0;
  }

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';

    this.loadData();
  }

  async loadData(): Promise<void> {
    if (!this.regionId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    try {
      const regionId = this.regionId;
      const infoData = await lastValueFrom(
        this.dataService.getHospitalInfoData(
          this.medicineId,
          this.countryId,
          regionId,
        ),
      );

      if (infoData.length > 0) {
        const rawList: any[] = infoData;

        const updatedRecords = await Promise.all(
          rawList.map(async (record) => {
            const processData = await lastValueFrom(
              this.dataService.getInclusionProcessData(
                this.medicineId,
                this.countryId,
                regionId,
                record.onekey,
              ),
            );

            const targetStep = (processData.steps || []).find(
              (step: any) => step.inEconomia === true,
            );

            if (!targetStep) {
              return null;
            }

            return {
              ...record,
              dueDate: targetStep.dueDate || '-',
              endDate: targetStep.endDate || '-',
              status: targetStep.status === 'COMPLETED' ? 'Open' : 'Closed',
            };
          }),
        );

        this.hospitalList = updatedRecords
          .filter((record: any) => record !== null)
          .sort((a: any, b: any) => {
            if (a.status === 'Open' && b.status === 'Closed') return -1;
            if (a.status === 'Closed' && b.status === 'Open') return 1;
            return (b.potentialNumber || 0) - (a.potentialNumber || 0);
          });

      } else {
        this.hospitalList = [];
      }
    } catch (error) {
      console.error('Errore durante il caricamento dei dati:', error);
      this.hospitalList = [];
    } finally {
      this.isLoading = false;
    }
  }

  oncloseModal(value: boolean) {
    this.isLoading = false;
    this.hospitalList = [];
    this.closeModal.emit(value);

    document.body.style.overflow = '';
    document.body.style.width = '';
  }
}